<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="article_view">
                    <div class="sub_nav"><a @click="goTo('/')">首页</a>|<a @click="goTo(page_url)">{{ page_title }}</a></div>
                    <h2>{{ article.title }}</h2>
                    <div class="datetime">{{ article.datetime }}</div>
                    <div class="main_content" v-html="article.content"></div>
                    <div class="newsSource" v-if="article.newsSource != ''">新闻来源：<a :href="article.newsSource" target="_blank">{{ article.newsSource }}</a></div>
                    <div class="other_news">
                        <a @click.stop="goTo_t( pre_newsType , pre_id )" style="font-size:12px;">上一条：{{ pre_title }}</a>
                        <a @click.stop="goTo_t( next_newsType , next_id )" style="font-size:12px;">下一条：{{ next_title }}</a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { XinWenView } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '公司简介',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            id: this.$route.query.id, //传入的id
            newsType : this.$route.query.newsType, //传入的webType
            page_url: this.$route.query.url, //传入的url
            page_title: this.$route.query.title, //传入的url

            pre_id:'43', //上一条新闻的id
            pre_newsType:'203', //上一条新闻的newsType
            pre_title: '热烈祝贺凯纳科技董事长田立坤再次当选省工商联副主席', //上一条新闻的newsType

            next_id:'41', //下一条新闻的id
            next_newsType:'203', //下一条新闻的newsType
            next_title: '喜讯！凯纳科技荣获“第十二届中国创新创业大赛黑龙江赛区暨第六届哈尔滨市地赛”成长组三等奖', //下一条新闻的newsType

            article: {
                title:'',
                datetime:'',
                content:'',
                newsSource:'',
                newsUrl:'',
            },
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.XinWenView_data( this.newsType, this.id );
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        goTo_t( type, id ){
            console.log( type );
            console.log( id );
            this.XinWenView_data( type, id );

            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        XinWenView_data( newsType, id ){ //文章分类显示
            XinWenView({
                newsType : newsType,
                id: id,
            }).then((res) => {
                this.article.title = res.rows[0].newsTitle;
                this.article.datetime = res.rows[0].createDate;
                this.article.content = res.rows[0].newsDetails;
                this.article.newsSource = res.rows[0].newsSource;
            });
        },
    },
};
</script>
<style lang="less" scoped>
.other_news{
    display: none;
    margin-top: 20px;
    background-color: #f0f0f0;
    padding: 5px;

    a{
        display: inline-block;
        height: 25px;
        line-height: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/XiWenView.vue